import {createRouter, createWebHistory} from 'vue-router'
import {useAuthStore} from '@/stores'

import Home from '@/views/Home.vue'
import Dashboard from '@/views/Dashboard.vue'
import Components from '@/views/Components.vue'
import NotFound from '@/views/NotFound.vue'
import Login from '@/views/LoginPage.vue'

import AirlineLayout from '@/views/AirlineLayout.vue'
import ChartererLayout from '@/views/ChartererLayout.vue'
import airline_routes from '@/router/airline'
import charterer_routes from '@/router/charterer'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {requiresAuth: true},
    beforeEnter: (to, from, next) => {
      const auth = useAuthStore()
      if (auth.user?.user_type === 'airline' || auth.user?.user_type === 'charterer') {
        return next({name: 'Dashboard'})
      }
      next()
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: async (to, from, next) => {
      const auth = useAuthStore()
      await auth.logout?.()
      next({name: 'Login'})
    },
    meta: {requiresAuth: false}
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {guestOnly: true}
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {requiresAuth: true},
  },
  {
    path: '/components',
    name: 'Components',
    component: Components,
    meta: {requiresAuth: false}
  },
  {
    path: '/airline',
    component: AirlineLayout,
    children: airline_routes,
    meta: {requiresAuth: true, allowedUserType: 'airline', breadcrumb: false}
  },
  {
    path: '/charterer',
    component: ChartererLayout,
    children: charterer_routes,
    meta: {requiresAuth: true, allowedUserType: 'charterer', breadcrumb: false}
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {requiresAuth: false}
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const auth = useAuthStore()

  const requiresAuth = to.matched.some(r => r.meta?.requiresAuth)
  const guestOnly = to.matched.some(r => r.meta?.guestOnly)
  const allowedUserType = to.matched.find(r => r.meta?.allowedUserType)?.meta.allowedUserType

  if (requiresAuth && !auth.isAuthenticated) {
    return {
      name: 'Login',
      query: {redirect: to.fullPath},
      replace: true,
    }
  }

  if (guestOnly && auth.isAuthenticated) {
    return {path: '/', replace: true}
  }

  if (requiresAuth && allowedUserType && !auth.user?.is_superuser) {
    if (auth.user?.user_type !== allowedUserType) {
      // opcional: manda a NotFound o a la home de su rol
      return {name: 'NotFound', replace: true}
    }
  }

  return true
})

export default router
